import {getAllStoryTags, createStoryTagCategory, createStoryTag, updateStoryTagCategory, updateStoryTag, updateCategoryOrder, getAllTagGroups, createTagGroup, updateTagGroup } from '../../api';
import {createAsyncThunk} from "@reduxjs/toolkit";
import store from "../../store";
import {setNotifications} from "../slices/notifications";

export const getStoryTags = createAsyncThunk(
    'storyTags/getStoryTags',
    async (queryParams:any, {rejectWithValue}) => {
        try {
            const stories = await getAllStoryTags(queryParams);
            return stories;
        } catch (error: any) {
            store.dispatch(setNotifications({text: error.message, type: 'error'}))
            return rejectWithValue(error.message)
        }
    }
)

export const createStoryTagThunk = createAsyncThunk(
    'storyTags/createStoryTag',
    async (
        data: { formData: { name: string; categoryId: number }; onSuccess?: (res: any) => void },
        { rejectWithValue }
    ) => {
        try {
            const response = await createStoryTag(data.formData);
            store.dispatch(setNotifications({ text: 'Tag created successfully', type: 'success' }));
            data.onSuccess?.(response);
            return response;
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message || 'Tag creation failed', type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);

export const CreateStoryTagCategory = createAsyncThunk(
    'storyTags/createStoryTagCategory',
    async (
        data: { formData: { name: string }; onSuccess?: (res: any) => void },
        { rejectWithValue }
    ) => {
        try {
            const response = await createStoryTagCategory(data.formData);
            store.dispatch(setNotifications({ text: 'Category created successfully', type: 'success' }));
            if (data.onSuccess) {
                data.onSuccess(response);
            }
            return response;
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message || 'Category creation failed', type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);

export const updateStoryTagThunk = createAsyncThunk(
    'storyTags/updateTag',
    async (
        data: {
            id: number;
            formData: { name: string; categoryId: number; isDeleted?: 0 | 1 };
            onSuccess?: (res: any) => void;
        },
        { rejectWithValue }
    ) => {
        try {
            const response = await updateStoryTag(data.id, data.formData);
            store.dispatch(setNotifications({ text: 'Tag updated', type: 'success' }));
            data.onSuccess?.(response);
            return response;
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message || 'Update failed', type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);

export const updateStoryTagCategoryThunk = createAsyncThunk(
    'storyTags/updateCategory',
    async (
        data: { id: number; formData: { name: string; isDeleted?: 0 | 1 }; onSuccess?: (res: any) => void },
        { rejectWithValue }
    ) => {
        try {
            const response = await updateStoryTagCategory(data.id, data.formData);
            store.dispatch(setNotifications({ text: 'Category updated', type: 'success' }));
            data.onSuccess?.(response);
            return response;
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message || 'Category update failed', type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);

export const updateCategoryOrderThunk = createAsyncThunk(
    'storyTags/updateCategoryOrder',
    async (
        payload: {
            categories: {
                id: number;
                order: number;
            }[];
            onSuccess?: () => void;
        },
        { rejectWithValue }
    ) => {
        try {
            const res = await updateCategoryOrder({ categories: payload.categories });
            payload.onSuccess?.();
            store.dispatch(setNotifications({ text: 'Category order updated successfully', type: 'success' }));
            return res;
        } catch (error:any) {
            store.dispatch(setNotifications({ text: error.message || 'Failed to update category order', type: 'error' }));
            return rejectWithValue(error);
        }
    }
);

export const getTagGroups = createAsyncThunk(
    'storyTags/getTagGroups',
    async (queryParams: { page?: number; perPage?: number; isDeleted?: 0 | 1 }, { rejectWithValue }) => {
        try {
            return await getAllTagGroups(queryParams);
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message, type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);

export const createTagGroupThunk = createAsyncThunk(
    'storyTags/createTagGroup',
    async (
        data: {
            formData: { name: string; tagIds: number[] };
            onSuccess?: (res: any) => void;
        },
        { rejectWithValue }
    ) => {
        try {
            const response = await createTagGroup(data.formData);
            store.dispatch(setNotifications({ text: 'Tag group created successfully', type: 'success' }));
            data.onSuccess?.(response);
            return response;
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message || 'Tag group creation failed', type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);

export const updateTagGroupThunk = createAsyncThunk(
    'storyTags/updateTagGroup',
    async (
        data: {
            id: number;
            formData: { name: string; isDeleted: 0 | 1; tagIds: number[] };
            onSuccess?: (res: any) => void;
        },
        { rejectWithValue }
    ) => {
        try {
            const response = await updateTagGroup(data.id, data.formData);
            store.dispatch(setNotifications({ text: 'Tag group updated', type: 'success' }));
            data.onSuccess?.(response);
            return response;
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message || 'Tag group update failed', type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);
